import { requests } from '../../api/services';
import { STATISTICS_URL } from '../../utils/Endpoints';
import { IActiveUser, IActiveUsers, IActiveUsersListParams, IStatisticData } from './dto/iStatistic';

export const StatisticsService = {
    getStatistics: (userType: string): Promise<IStatisticData> => requests.get(`${STATISTICS_URL}/${userType}`),
    getStatisticsOffers: (params: any): Promise<any> => requests.get(`${STATISTICS_URL}/offers`, params),
    getActiveUsers: (minutes: number): Promise<IActiveUsers> =>
        requests.get(`${STATISTICS_URL}/active-users`, { minutes }),
    getActiveUsersList: (
        params: IActiveUsersListParams
    ): Promise<{ data: IActiveUser[]; count: number; page: number; perPage: number }> =>
        requests.get(`${STATISTICS_URL}/active-users/users`, params),
};
